import { useEffect } from "react";
import { connect } from "react-redux";

// Actions Imports
import {
  reactionsOnRedoClick,
  reactionsOnUndoClick,
} from "../../actions/DocumentActions/index";

const UndoRedoObserver = props => {
  const _keyDownHandler = event => {
    if (
      event.shiftKey &&
      (event.ctrlKey || event.metaKey) &&
      (event.key === "z" || event.key === "Z")
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      props.reactionsOnRedoClick();
    } else if (
      !event.shiftKey &&
      (event.ctrlKey || event.metaKey) &&
      (event.key === "z" || event.key === "Z")
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      props.reactionsOnUndoClick();
    } else if ((event.ctrlKey || event.metaKey) && event.key === "y") {
      event.preventDefault();
      event.stopImmediatePropagation();
      props.reactionsOnRedoClick();
    }
  };

  // This guarantees only one listner is attached
  useEffect(() => {
    document.addEventListener("keydown", _keyDownHandler);
  });
  return null;
};

const mapDispatchToProps = {
  reactionsOnRedoClick,
  reactionsOnUndoClick,
};

export default connect(
  null,
  mapDispatchToProps,
)(UndoRedoObserver);



// WEBPACK FOOTER //
// ./src/components/UndoRedoObserver/index.js